import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useWatcherButton } from '../search-watcher/useWatcherButton';
import {
  PrimaryButton,
  SecondaryHyperlink,
  PrimaryHyperlink,
  SecondaryButton,
} from '../../../components/button';
import { DeleteWatcherButton } from '../../../watchers/components/delete-watcher-button/DeleteWatcherButton';
import { askForDecisionAnalytics } from '../../../decision/decisionUtils';
import styles from './zero_decision_results_buttons.module.scss';
import { useDecisionWatcherModal } from '../search-watcher/useDecisionWatcherModal';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { useUser } from '../../../user/useUser';

export const ZeroDecisionResultsButtonDecisionRef: FC = () => {
  const source = 'search_decision_zero_result';
  const [createWatcher, isWatched, deleteWatcher] = useWatcherButton({
    source,
  });
  const openModal = useDecisionWatcherModal({ createWatcher });
  const { openRestrictedModal } = useRestrictedModal();
  const { accessPremium } = useUser();

  const createDecisionWatcher = () => {
    if (accessPremium) {
      openModal();
    } else {
      openRestrictedModal({ source });
    }
  };
  return (
    <>
      <PrimaryHyperlink
        key="1"
        href="/getdecision"
        source="search-zero-results"
        target="_blank"
        data-test-id="ask-a-decision"
        onClick={askForDecisionAnalytics('no_result_page', {
          type: 'primary',
          reportOriginalQueryKey: true,
        })}
      >
        <FormattedMessage id="search/zero-results/ZeroDecisionResultsButtons.tsx/2" />
      </PrimaryHyperlink>
      <div className={styles.secondary}>
        {!isWatched ? (
          <SecondaryButton
            iconLeft="notifications_none"
            onClick={createDecisionWatcher}
          >
            <FormattedMessage id="search/zero-results/ZeroDecisionResultsButtons.tsx/1" />
          </SecondaryButton>
        ) : (
          <DeleteWatcherButton
            deleteWatcher={deleteWatcher}
            tooltipId="search-decision-watcher-button-noresult"
          />
        )}
      </div>
    </>
  );
};

export const ZeroDecisionResultsButtonOther: FC = () => {
  const source = 'search_decision_zero_result';
  const [createWatcher, isWatched, deleteWatcher] = useWatcherButton({
    source,
  });
  const openModal = useDecisionWatcherModal({ createWatcher });
  const { openRestrictedModal } = useRestrictedModal();
  const { accessPremium } = useUser();

  const createDecisionWatcher = () => {
    if (accessPremium) {
      openModal();
    } else {
      openRestrictedModal({ source });
    }
  };

  return (
    <>
      {!isWatched ? (
        <PrimaryButton
          iconLeft="notifications_none"
          onClick={createDecisionWatcher}
        >
          <FormattedMessage id="search/zero-results/ZeroDecisionResultsButtons.tsx/1" />
        </PrimaryButton>
      ) : (
        <DeleteWatcherButton
          deleteWatcher={deleteWatcher}
          tooltipId="search-decision-watcher-button-noresult"
        />
      )}

      <div className={styles.secondary}>
        <SecondaryHyperlink
          key="1"
          href="/getdecision"
          source="search-zero-results"
          target="_blank"
          data-test-id="ask-a-decision"
          onClick={askForDecisionAnalytics('no_result_page', {
            type: 'secondary',
            reportOriginalQueryKey: true,
          })}
        >
          <FormattedMessage id="search/zero-results/ZeroDecisionResultsButtons.tsx/2" />
        </SecondaryHyperlink>
      </div>
    </>
  );
};
